import { useRef } from 'react';
import type ReactEChartsCore from 'echarts-for-react/lib/core';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import Flex from '@/components/common/Flex';
import BarChartSkeleton from '@/app/common/components/skeleton/BarChartSkeleton';
import healthScoreColorAndLabel from '@/helpers/healthScoreColorAndLabel';
import CardChartDropDown from '@/components/common/CardChartDropDown';
import MainBarChart from '@/app/common/components/charts/BarChart';
import { Card } from 'react-bootstrap';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';
import { getColor } from '@/helpers/utils';
import CustomLegent from '@/app/common/components/charts/CustomLegent';

interface CrawlHistoryRow {
  host_name: string;
  health_score?: number | string | null;
}

interface CrawlBarCardHealthProps {
  data: CrawlHistoryRow[];
  isLoading: boolean;
}

/*  نمودار میزان سلامت سایت در صفحه تاریخچه */
const CrawlBarCardHealth = ({
  data,
  isLoading
}: CrawlBarCardHealthProps) => {
  const cardRef = useRef<HTMLDivElement | null>(null);
  const chartRef = useRef<ReactEChartsCore | null>(null);
  const series = [
    {
      name: 'سلامت',
      data: data
        .filter(({ health_score }) => health_score)
        .map(({ health_score }) => ({
          name: healthScoreColorAndLabel(health_score).label,
          value: health_score,
          itemStyle: {
            color: healthScoreColorAndLabel(health_score).color
          }
        })),
      itemStyle: {
        borderRadius: [3, 3, 0, 0],
        color: getColor('success')
      }
    }
  ];
  if (isLoading) return <BarChartSkeleton length={10} />;

  return (
    data && (
      <Card ref={cardRef} className="h-100">
        <FalconCardHeader
          title={
            <div>
              سلامت سایت
              <HelpTooltip html={crawlTooltip.crawlerHistory.health_score} />
            </div>
          }
          titleTag="h6"
          className="py-2"
          light
          endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
        />
        <Card.Body
          as={Flex}
          direction="column"
          justifyContent="between"
          className="py-3"
        >
          <MainBarChart
            chartRef={chartRef}
            height={250}
            categories={data
              .filter(({ health_score }) => health_score)
              .map(item => item.host_name)}
            series={series}
          />
        </Card.Body>
        <div className="d-flex mt-n4 mb-3 gap-2 justify-content-center pt-1 align-items-center">
          {series.map(item => (
            <CustomLegent
              key={item.name}
              name={item.name}
              chartRef={chartRef}
              color={item.itemStyle.color}
            />
          ))}
        </div>
      </Card>
    )
  );
};
export default CrawlBarCardHealth;
